import { makeStyles } from '@material-ui/core';
import logo from './assets/aeven-oneplatform-logo.png';
import { LOGO_ASPECT, LOGO_CREAM, LOGO_PADDING } from './brand';

const HEIGHT = 46;
const PAD = Math.round(HEIGHT * LOGO_PADDING);
const ART = HEIGHT - 2 * PAD;

const useStyles = makeStyles(theme => ({
  plate: {
    display: 'inline-flex',
    alignItems: 'center',
    height: HEIGHT,
    padding: PAD,
    boxSizing: 'border-box',
    borderRadius: theme.shape.borderRadius,
    // The logo needs a light ground of its own; see the note in ./brand.
    background: LOGO_CREAM,
  },
  logo: {
    height: ART,
    width: ART * LOGO_ASPECT,
    display: 'block',
  },
}));

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <span className={classes.plate}>
      <img className={classes.logo} src={logo} alt="Aeven OnePlatform" />
    </span>
  );
};
